/**
 * Centralized Version Configuration
 * 
 * UPDATE VERSION HERE - This is the single source of truth for the app version.
 * All components should import from this file instead of using hardcoded values.
 * 
 * To update the version:
 * 1. Change VERSION_STRING below
 * 2. Update REACT_APP_VERSION in /app/frontend/.env to match
 * 
 * Format: MSP B{major}.{minor}.{patch}-CF{cf_version}-{MMDDYYYY}
 */

export const VERSION_STRING = "MSP B3.0.2-CF5-01092026";

// Get version from environment variable with fallback to centralized config
export const getAppVersion = () => {
  return process.env.REACT_APP_VERSION || VERSION_STRING;
};

// Version metadata (parsed from VERSION_STRING)
export const VERSION_INFO = {
  major: 3,
  minor: 0,
  patch: 2,
  cf: 5,
  date: "2026-09-01",
  build: "01092026",
  full: VERSION_STRING
};

export default VERSION_STRING;
